import React, { PropsWithChildren, useContext } from 'react';
import { useQuery } from 'react-query';
import { TopicTreeNode } from '@osmosis/shared/types/learn';
import { useFetch } from './FetchProvider';
import { useUserContext } from './UserContext';

/** Navs rendered in the footer rather than as content topics. */
export const footerNavs = [
  'featured-series',
  'core-competencies',
  'professional-success',
];

export type NavsContextProps = {
  navs: TopicTreeNode[];
  isLoading: boolean;
};

const NavsContext = React.createContext<NavsContextProps>({
  navs: [],
  isLoading: false,
});

/**
 * Navs provider.
 */
export const NavsProvider = (props: PropsWithChildren) => {
  const { children } = props;
  const { get } = useFetch();
  const { user } = useUserContext();

  const { data, isLoading } = useQuery(
    ['user-navs'],
    async () => {
      const response = await get<{ topics: TopicTreeNode[] }>(
        '/v0/mobile_topic?includeNotes=true',
      );
      return response?.data;
    },
    {
      enabled: !!user,
    },
  );

  const { topics } = data || { topics: [] };

  const navs = topics.filter((topic) => !footerNavs.includes(topic.name));

  return (
    <NavsContext.Provider
      value={{
        navs,
        isLoading,
      }}
    >
      {children}
    </NavsContext.Provider>
  );
};

/**
 * Hook to access the topics context.
 */
export const useNavsContext = (): NavsContextProps => useContext(NavsContext);
